export default "__VITE_ASSET__wEjqmRhJ__"